/**
 * Whether the onboarding feature is on (decision 32). Temporary: there is no API yet, so the feature runs on
 * mock data, which must never reach production. Delete this gate when the API arrives.
 *
 * Lives in presentation: the domain stays free of env and the app shell, and showing a route or a card is a
 * UI concern. The env is read in the repo's one place, `ENV` from src/config/env.ts.
 */
import { ENV } from '@/config/env';

export function isOnboardingEnabled(env: string | undefined = ENV): boolean {
  return env !== 'prod';
}

/**
 * The gate for this build. Written as a plain comparison (not a call) so a production build folds it to the
 * constant false and drops the lazy page import, and with it the page and mock-data chunks: nothing of the
 * feature ships to prod. Verified on a production build; a test keeps it equal to isOnboardingEnabled().
 */
export const ONBOARDING_ENABLED = ENV !== 'prod';
